export const SELECT_MODAL_CONTROLLER = "report-dashboard-ds-select-modal"
export const FILTER_ASSESSMENT_CONTROLLER = "report-dashboard-ds-filter-assessment"

export const SELECT_TYPES = {
  course: {
    modalId: "selectCourseModal",
    fetchUrl: "/report_dashboard/courses.json",
    placeholder: "Select Course",
    loadingMessage: "Loading courses...",
    emptyMessage: "No results found - create a course to view reports",
    errorMessage: "Unable to load courses",
    viewReportLabel: "View report for selected course",
  },
  student: {
    modalId: "selectStudentModal",
    fetchUrl: "/report_dashboard/students.json",
    placeholder: "Select Student",
    loadingMessage: "Loading students...",
    emptyMessage: "No results found - create a course to view reports",
    errorMessage: "Unable to load students",
    viewReportLabel: "View report for selected student",
    reportUrl: (selectedId) => `/reports/student_report/${selectedId}`,
  },
  case: {
    modalId: "selectCaseOrScriptModal",
    fetchUrl: "/report_dashboard/cases_and_scripts.json",
    placeholder: "Select Case/Script",
    loadingMessage: "Loading cases/scripts...",
    emptyMessage: "No results found - create a course to view reports",
    errorMessage: "Unable to load cases/scripts",
    viewReportLabel: "View report for selected case or script",
    reportUrl: (selectedId) => `/reports/case_report/${selectedId}`,
  },
}

export const MODAL_ACTIONS = {
  openCourseModal: {
    modalId: SELECT_TYPES.course.modalId,
    afterOpen(controller) {
      controller.modalController(SELECT_MODAL_CONTROLLER)?.load("course")
    },
  },
  openStudentModal: {
    modalId: SELECT_TYPES.student.modalId,
    afterOpen(controller) {
      controller.modalController(SELECT_MODAL_CONTROLLER)?.load("student")
    },
  },
  openCaseModal: {
    modalId: SELECT_TYPES.case.modalId,
    afterOpen(controller) {
      controller.modalController(SELECT_MODAL_CONTROLLER)?.load("case")
    },
  },
  openAssessmentsModal: {
    modalId: "selectAssessments",
    afterOpen(controller, event) {
      controller.modalController(FILTER_ASSESSMENT_CONTROLLER)?.open(event)
    },
  },
}
